var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 184,
    viewBox: "0 0 183 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0281 23.7825H45.8636V46.618H23.0281V23.7825Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6992 0.94696V69.4535H0.192627V0.94696H68.6992ZM57.2814 12.3647H11.6104V58.0357H57.2814V12.3647ZM45.8637 137.96H23.0281V160.796H45.8637V137.96Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6992 115.125V183.631H0.192627V115.125H68.6992ZM11.6104 126.542V172.213H57.2814V126.542H11.6104ZM137.206 23.7825H160.041V46.618H137.206V23.7825Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.37 0.94696V69.4535H182.877V0.94696H114.37ZM171.459 12.3647V58.0357H125.788V12.3647H171.459ZM91.5347 12.3647V0.94696H102.952V23.7825H91.5347V46.618H80.1169V12.3647H91.5347ZM91.5347 69.4535V46.618H102.952V69.4535H91.5347ZM68.6992 92.289V80.8713H80.1169V69.4535H91.5347V92.289H102.952V80.8713H160.041V92.289H114.37V103.707H80.1169V92.289H68.6992ZM68.6992 92.289V103.707H23.0281V92.289H11.6104V103.707H0.192627V80.8713H34.4459V92.289H68.6992ZM182.877 103.707H171.459V80.8713H182.877V103.707ZM171.459 103.707H160.041V126.542H182.877V115.125H171.459V103.707ZM125.788 103.707H148.623V115.125H137.206V126.542H125.788V103.707ZM148.623 137.96V126.542H137.206V137.96H125.788V149.378H102.952V160.796H137.206V137.96H148.623ZM148.623 137.96H182.877V149.378H160.041V160.796H148.623V137.96ZM102.952 126.542V137.96H114.37V115.125H80.1169V126.542H102.952Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1169 137.96H91.5347V172.213H137.206V183.631H80.1169V137.96ZM182.877 160.795V183.631H148.623V172.213H171.459V160.795H182.877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.e603b11fc56f5ad06c80dee5a2e8a410.svg";
export { ForwardRef as ReactComponent };